import React from 'react';
import { motion } from 'motion/react';
import { Sparkles, TrendingUp, Calendar, BarChart3 } from 'lucide-react';

const iconMap = {
  Sparkles: Sparkles,
  TrendingUp: TrendingUp,
  Calendar: Calendar,
  BarChart3: BarChart3
};

const FeatureCard = ({ feature, index }) => {
  const IconComponent = iconMap[feature.icon] || Sparkles;

  return (
    <motion.div
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: '-50px' }}
      transition={{
        type: 'spring',
        damping: 80,
        stiffness: 400,
        delay: index * 0.1
      }}
      whileHover={{ y: -8, transition: { duration: 0.3 } }}
      className="group relative p-6 md:p-8 rounded-2xl bg-white/80 backdrop-blur-sm border border-white/50 shadow-lg hover:shadow-xl transition-shadow duration-300"
    >
      {/* Gradient background on hover */}
      <div className="absolute inset-0 rounded-2xl bg-gradient-to-br from-[#D98A8C]/5 via-[#E1C567]/5 to-[#DFB573]/5 opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
      
      <div className="relative">
        <motion.div
          whileHover={{ scale: 1.1, rotate: 5 }}
          transition={{ type: 'spring', stiffness: 400, damping: 25 }}
          className="w-14 h-14 rounded-2xl bg-gradient-to-br from-[#D98A8C]/20 via-[#E1C567]/20 to-[#DFB573]/20 flex items-center justify-center mb-5"
        >
          <IconComponent className="w-7 h-7 text-[#0A6647]" />
        </motion.div>
        
        <h3
          className="text-xl font-semibold text-[#0A0A0A] mb-3"
          style={{ fontFamily: 'Inter, sans-serif' }}
        >
          {feature.title}
        </h3>
        
        <p
          className="text-[#3C3B3D] leading-relaxed"
          style={{ fontFamily: 'Inter, sans-serif' }}
        >
          {feature.description}
        </p>
      </div>
    </motion.div>
  );
};

export default FeatureCard;
